module.exports = __webpack_public_path__ + "img/pick4.7c4576a9.png";